import React from 'react';
import classes from './Logo.module.scss';
import {ReactComponent as LightLogo} from "../../../assets/images/logo.svg";


export const Logo = () => {
    return (
        <div className={classes['logo']} data-testid={'logo'}>
            <LightLogo />
        </div>
    );
};

Logo.propTypes = {

}